var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import MuiButtonBase from '@material-ui/core/ButtonBase';
import { styled } from '../../../foundation';
/** @release */
var RcButtonBase = styled(MuiButtonBase)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
RcButtonBase.displayName = 'RcButtonBase';
export { RcButtonBase };
var templateObject_1;
